import { getConfig } from '@klpkonsern/appconfig';

export const getSoLinkWithClientId = (soClientId: number) =>
    getConfig('WEBAPP_APP_SUPEROFFICE_LINK', '').concat(
        '?contact.main.personarchive?contact_id=',
        soClientId.toString(),
    );
